import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
    CardElement,
    Elements,
    useElements,
    useStripe,
    CardElementComponent
} from "@stripe/react-stripe-js";
import "./styles.css";
import {  AxiosInstance } from "../../utils/RequestMethods";
import config from "../../constants/config";
import { Container, Spinner } from "react-bootstrap";
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe(config.stripePublishableKey);

const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto"
        }
    ]
};



const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
        base: {
            iconColor: "#515e80",
            color: "#444",
            fontWeight: 500,
            lineHeight: `50px`,
            fontFamily: `"proxima-nova", "proxima nova", "helvetica neue", "helvetica", "arial", sans-serif`,
            fontSize: "16px",
            fontSmoothing: "antialiased",
            ":-webkit-autofill": {
                color: "#444"
            },
            "::placeholder": {
                color: "#444"
            }
        },
        invalid: {
            iconColor: "#515e80",
            color: "#ffc7ee"
        }
    }
};




const CardField = ({ onChange }) => {
    const [error, setError] = useState(null);

    return (

        <>
            <div className="stripe-row wrapper-stripe-card" >

                <CardElement
                    // @ts-ignore
                    options={CARD_OPTIONS}
                    onChange={(e) => {
                        setError(e.error);
                        onChange(e)
                    }} />


            </div>

            {/* {error && <div className="stripe-row"><span className="text-danger">{error.message}</span> </div>} */}
        </>
    )
};

const Field = ({
    label,
    id,
    type,
    placeholder,
    required,
    autoComplete,
    value,
    onChange
}) => (
    <div className="stripe-row form-row">
        <label htmlFor={id} className="form-label">
            {label}
        </label>
        <input
            className="form-control"
            id={id}
            type={type}
            placeholder={placeholder}
            required={required}
            // autoComplete={autoComplete}
            value={value}
            onChange={onChange}
        />
    </div>
);


/**
 *
 * @param param0
 * @returns
 */
const ErrorMessage = ({ onClose, children }) => {
    const [showError, setShowError] = React.useState(false);


    return (

        <div className="error-message alert alert-danger" role="alert">
            {/* <span onClick={() => {
                onClose()
            }}> <svg width="16" height="16" viewBox="0 0 17 17">
                    <path
                        fill="#FFF"
                        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
                    />
                    <path
                        fill="#6772e5"
                        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
                    />
                </svg>
            </span> */}
            {children}
        </div>
    )

}



export declare interface KeyValue<K, V> {
    key: K;
    value: V;
}
export interface BillingDetailsAddressT {

    city?: string;
    country?: string;
    line1?: string;
    line2?: string;
    postal_code?: string;
    state?: string;
}
export interface BillingDetailsT {

    address?: BillingDetailsAddressT;
    email?: string;
    name?: string;
    phone?: string;
}
type MappedDataT = {
    [key: string]: any
};

interface PayloadPaymentIntentT {
    amount: number
    paymentMethodId: string
}
interface ICheckoutFormProps {

    amount: number

    billingDetails?: BillingDetailsT
    createPaymentIntent(data: PayloadPaymentIntentT): Promise<string>
    onSuccessPaymentIntent(paymentIntentId: string): Promise<string>
    labelButton?: string
    renderSuccessResult?: React.ReactNode
}

const CheckoutForm: React.FC<ICheckoutFormProps> = (props) => {
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorCard, setErrorCard] = useState(null);
    const [cardComplete, setCardComplete] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [clientSecret, setClientSecret] = useState('');

    const [paymentIntentId, setPaymentIntentId] = useState(null);
    const [paymentIntentResault, setPaymentIntentResault] = useState(null);
    const [billingDetails, setBillingDetails] = useState<BillingDetailsT>({
        email: null,
        phone: null,
        name: "",
        address: null
    });


    React.useEffect(() => {
        // if (props.billingDetails) {
        //     setBillingDetails(props.billingDetails)
        // }

    }, [])


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        if (errorCard) {
            elements.getElement("card").focus();
            return;
        }

        if (cardComplete) {
            setProcessing(true);
        }



        try {
            let paymentMethodId = null
            if (!paymentMethod) {
                /**
                 * step 1
                 */
                const payload = await stripe.createPaymentMethod({
                    type: "card",
                    card: elements.getElement(CardElement),
                    billing_details: billingDetails
                });



                if (payload.error) {
                    setErrorMessage(payload.error);
                    setProcessing(false);
                    throw new Error(`${payload.error.message}`);

                } else {
                    paymentMethodId = payload.paymentMethod.id
                    setPaymentMethod(payload.paymentMethod);
                }
            } else {
                paymentMethodId = paymentMethod.id
            }

            /**
             * step 2
             */

            const res = await createPaymentIntent(props.amount, paymentMethodId);
            setClientSecret(res)


            /**
             * step 3
             */
            const intentId = await confirmCardPayment(res, CardElement, billingDetails);
            setPaymentIntentId(intentId)
        } catch (error) {
            setProcessing(false);
            setErrorMessage(error);
            throw new Error(error);
        }
    };



    /**
     *
     * @param params
     * @returns
     */
    const createPaymentMethod = async (params): Promise<any> => {
        try {
            const payload = await stripe.createPaymentMethod(params);

            setProcessing(false);

            if (payload.error) {
                setErrorMessage(payload.error);
                throw new Error(`${payload.error.message}`);

            } else {
                setPaymentMethod(payload.paymentMethod);
                return payload;
            }
        } catch (error) {
            setErrorMessage(error);
            throw new Error(error);

        }
    }

    /**
     *
     * @param params
     */
    const createPaymentIntent = async (amount: number, paymentMethodId: string): Promise<string> => {
        let params = {
            amount: amount,
            paymentMethodId: paymentMethodId
        }

        console.log("createPaymentIntent->params", params)
        try {
            const resClientSecret = await props.createPaymentIntent(params);
            return resClientSecret;
        } catch (error) {
            setPaymentMethod(null);
            throw new Error(error);
        }
    }

    /**
     *
     * @param CardElement
     * @param clientSecret
     * @returns
     */
    const confirmCardPayment = async (clientSecret: string, CardElement: CardElementComponent, billingDetails: BillingDetailsT): Promise<string> => {

        let stripeDataObject = {
            payment_method: {
                card: elements.getElement(CardElement),
                billing_details: billingDetails
            },

        }
        try {

            const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, stripeDataObject);
            if (error) {
                setProcessing(false);
                setErrorMessage(error.message)
                throw new Error(error.message);
            } else if (paymentIntent && paymentIntent.status === "succeeded") {
                const result = await props.onSuccessPaymentIntent(paymentIntent.id)
                if (result) {

                }
                setTimeout(() => {
                    setProcessing(false);
                    setPaymentIntentResault(paymentIntent)
                }, 500);

                console.log("confirmCardPayment->onSuccessPaymentIntent->result", result)
                return paymentIntent.id;
            }

            throw new Error(paymentIntent.status);
        } catch (error) {
            setProcessing(false)
            setPaymentMethod(null);
            throw new Error(error);
        }
    }


    const reset = () => {
        setErrorMessage(null);
        setProcessing(false);
        setPaymentMethod(null);
        setBillingDetails({
            email: "",
            phone: "",
            name: "",
        });
    };


    /**
     *
     * @returns
     */
    const renderResult = (): JSX.Element => {
        if (props.renderSuccessResult) {

            return (
                <div>
                    {props.renderSuccessResult}
                </div>
            )
        }
        return (
            <div className="result">
                <div className="result-title" role="alert">
                    Payment captured
                </div>
            </div>
        )
    }


    /**
     *
     * @returns
     */
    const renderForm = (): JSX.Element => {
        return (
            <form className="form" onSubmit={handleSubmit}>

                <div className="stripe-row-input form-group">
                    <Field
                        label=""
                        id="name"
                        type="text"
                        placeholder="Cardholder name"
                        required
                        autoComplete="name"
                        value={billingDetails.name}
                        onChange={(e) => {
                            setBillingDetails({ ...billingDetails, name: e.target.value });
                        }}
                    />

                    {/* <Field
                        label="Email"
                        id="email"
                        type="email"
                        placeholder=""
                        required
                        autoComplete="email"
                        value={billingDetails.email}
                        onChange={(e) => {
                            setBillingDetails({ ...billingDetails, email: e.target.value });
                        }}
                    /> */}
                    {/* <Field
                        label="Phone"
                        id="phone"
                        type="tel"
                        placeholder=""
                        required
                        autoComplete="tel"
                        value={billingDetails.phone}
                        onChange={(e) => {
                            setBillingDetails({ ...billingDetails, phone: e.target.value });
                        }}
                    /> */}
                </div>

                <div className="form-group">
                    <CardField
                        onChange={(e) => {
                            setErrorCard(e.error)
                            setErrorMessage(e.error);
                            setCardComplete(e.complete);
                        }}
                    />
                </div>
                {/* <h3>Billing Address</h3>
            <div className="stripe-row-input form-group">
                <Field
                    label=""
                    id="name"
                    type="text"
                    placeholder="Address Line 1"
                    required
                    autoComplete="name"
                    value={billingDetails.name}
                    onChange={(e) => {
                        // setBillingDetails({ ...billingDetails, line1: e.target.value });
                    }}
                />
            </div> */}
                {errorMessage && <ErrorMessage onClose={() => {
                    setErrorCard(null)
                    setErrorMessage(null)

                }}>{errorMessage.message}</ErrorMessage>}

                <button
                    className={`stripe-submit-button  mt-2 btn btn-primary ${errorMessage ? "stripe-submit-button--error" : ""}`}
                    type="submit"
                    disabled={processing || !stripe}
                >
                    {processing ? <> <Spinner animation="border" size="sm" /> Processing...</> : `${props.labelButton}`}
                </button>

            </form>

        )
    }


    return (paymentIntentResault && !processing)
        ? renderResult()
        : renderForm();
};



const devPublishableKeyGet = (): Promise<any> => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({ data: { publishableKey: config.stripePublishableKey } })
        }, 50);
    })
}



export const publishableKeyGet = async (userId: number = null): Promise<string> => {
    let params = {

    }
    const url = `${config.url.payments}/stripe/token`
    return new Promise(async resolve => {
      let options={
        data:params
      }
        const { data: { publishableKey } } = config.isProduction ? await AxiosInstance.get(url, options) : await devPublishableKeyGet();
        resolve(publishableKey)
    })
}


export type IFormStripeProps = {
    amount: number
    publishableKey: string
    billingDetails?: BillingDetailsT
    createPaymentIntent?(data: PayloadPaymentIntentT): Promise<string>
    onSuccessPaymentIntent(paymentIntentId: string): Promise<string>
    renderSuccessResult?: React.ReactNode
    labelButton?: string
}

const FormStripe: React.FC<IFormStripeProps> = (props) => {
    const [stripePromise, setStripePromise] = useState(null)
    React.useEffect(() => {
        // const retrievePublishableKey = async () => {
        //     const publishableKey = await publishableKeyGet()
        //     console.log("publishableKey",publishableKey)
        //     const stripe = loadStripe(publishableKey);
        //     setStripePromise(stripe)
        // }
        // retrievePublishableKey()
    }, []);


    React.useEffect(() => {

        initloadStripe()

    }, [])
    const initloadStripe = async () => {
        const stripe = await loadStripe(props.publishableKey);
        setStripePromise(stripe)

    }
    // console.log("stripePromise", stripePromise)
    if (!stripePromise) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" variant="info" />
            </Container>
        )
    }



    return (
        <div className=" mt-2 mb-2 ">
            <div className="d-flex">
                <div className="" style={{ width: "100%" }}>
                    <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
                        <CheckoutForm
                            amount={props.amount}
                            billingDetails={props.billingDetails}
                            createPaymentIntent={props.createPaymentIntent}
                            onSuccessPaymentIntent={props.onSuccessPaymentIntent}
                            labelButton={props.labelButton}
                            renderSuccessResult={props.renderSuccessResult}
                        />
                    </Elements>
                </div>
            </div>
        </div>
    );
}
FormStripe.defaultProps = {
    labelButton: "Pay Now"
}
export default FormStripe;
export { FormStripe };
